import { GearInstance, StepperStep } from 'types';

export const getInitialStep = (instance: GearInstance, onPass: (data: any) => void): StepperStep => ({
  stepName: 'Deal Type',
  onPass: (data: any) => {
    onPass(data);
  },
  formProps: {
    buttonCaption: 'Next',
    withFooter: true,
    buttonsShape: 'slimy',
    alignButtons: 'alignRight',
    marginMode: 'low',
    fields: [
      {
        type: 'secondTitle',
        fieldName: 'step_title',
        value: 'Select a Deal Type',
      },
      {
        type: 'description',
        fieldName: 'step_description',
        value: 'You can either Sell or Rent your gear on SENDY.',
      },
      {
        type: 'reachRadioBlock',
        fieldName: 'type',
        value: instance?.type,
        isDisabled: !!instance?.type,
        reachOptions: [
          {
            icon: '/icons/commerce/TagDark.svg',
            caption: 'I Want to Sell Gear',
            option: 'sell',
          },
          {
            icon: '/icons/people/HandshakeDark.svg',
            caption: 'I Want to Rent Gear',
            option: 'rent',
          },
        ],
      },
    ],
  },
});
